import React from 'react';
//components
import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import Button from '../../components/generics/Button';
import { Button as ButtonSave } from 'components/Button';
//interfaces
import { IMappingHeader } from './interface';
import { HeaderComponent, HeaderInfo } from './styles';
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";

const MappingHeader: React.FC<IMappingHeader> = (props) => {
  const {
    endSecondRenderMapProduct,
    updateListMapProduct,
    onCloseAction,
    quoteItemData,
    setModalSave,
    isMapProduct,
    disableBtn,
    detail,
    save
  } = props;

  const { quoteDetail } = useDetailsQuoteContext();

  const closeButton = () => {
    isMapProduct && updateListMapProduct();
    onCloseAction();
  };

  return (
    <HeaderComponent className='header-container'>
      <HeaderInfo>
        <Row className='customer-info'>
          <Text className="main-title color-primaryViveo" showTip>
            {!isMapProduct ? quoteDetail?.customerName : detail.quoteDetail.customerName}
          </Text>
          <Text className="sub-title font-italic" size={12}>
            Código interno {!isMapProduct ? quoteDetail?.quoteCode : detail.quoteDetail.quoteCode} / Código Cliente{' '}
            {!isMapProduct ? quoteDetail?.customerCode : detail.quoteDetail.customerCode}
          </Text>
        </Row>
        <Row className='quote-solicitation'>
          <Column>
            <Row className='solicitation-title'><Text>Item</Text></Row>
            <Row className='solicitation-data'><Text>{quoteItemData?.sequenceNumber}</Text></Row>
          </Column>
          <Column>
            <Row className='solicitation-title'><Text>Cód. Produto</Text></Row>
            <Row className='solicitation-data'><Text>{quoteItemData?.productCode || quoteItemData?.code}</Text></Row>
          </Column>
          <Column>
            <Row className='solicitation-title'><Text>Descrição</Text></Row>
            <Row className='solicitation-data'><Text showTip={!!quoteItemData?.productName} showTipContent={quoteItemData?.productName}>{quoteItemData?.productName}</Text></Row>
          </Column>
          <Column>
            <Row className='solicitation-title'><Text>Unidade</Text></Row>
            <Row className='solicitation-data'><Text> {quoteItemData?.unit}</Text></Row>
          </Column>
          <Column>
            <Row className='solicitation-title'><Text>Qtd.</Text></Row>
            <Row className='solicitation-data'><Text>{quoteItemData?.quantity}</Text></Row>
          </Column>
          <Column>
            <Row className='solicitation-title'><Text>Marca</Text></Row>
            <Row className='solicitation-data'><Text showTip>{quoteItemData?.producer ? quoteItemData?.producer : '-'}</Text></Row>
          </Column>
        </Row>
      </HeaderInfo>

      <Row className="mt-sm-2 mt-md-2 action-bar">
        <Column className="mr-3">
          <Button
            label="Fechar"
            onClick={() => {
              endSecondRenderMapProduct && (disableBtn ? closeButton() : setModalSave(true));
            }}
            className={`${!endSecondRenderMapProduct ? "cursor-not-allowed" : ""}`}
            width={154}
            second
          />
        </Column>
        <ButtonSave
          width={154}
          onClick={() => endSecondRenderMapProduct && save()}
          className={`button ml-2 px-2 ${disableBtn ? 'bg-dark-gray' : 'bg-greenDarkViveo'} ${!endSecondRenderMapProduct ? "cursor-not-allowed" : ""}`}
          disabled={disableBtn}
        >
          <Text color="#ffffff" size={14}>
            Salvar De/Para
          </Text>
        </ButtonSave>
      </Row>
    </HeaderComponent>
  );
};

export default MappingHeader;